import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelyCreditagricoleMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="caGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#004D40", stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: "#00796B", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#4CAF50", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <rect width={width} height={height} fill="url(#caGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {Array.from({ length: 14 }).map((_, i) =>
          Array.from({ length: 18 }).map((_, j) => {
            const x = -315 + i * 45;
            const y = -405 + j * 45;
            const isGreen = Math.sin(i * 0.5) * Math.cos(j * 0.5) > 0;
            return (
              <circle
                key={`field-${i}-${j}`}
                cx={x}
                cy={y}
                r={10}
                fill={isGreen ? "#4CAF50" : "none"}
                stroke="#FFFFFF"
                strokeWidth={1}
                opacity={isGreen ? 0.3 : 0.15}
              />
            );
          })
        )}
        {Array.from({ length: 16 }).map((_, r) => (
          <circle
            key={`growth-${r}`}
            cx={0}
            cy={0}
            r={(r + 1) * 24}
            fill="none"
            stroke="#FFFFFF"
            strokeWidth={r % 4 === 0 ? 2.5 : 1.5}
            opacity={0.3 - r * 0.014}
          />
        ))}
        <circle cx={0} cy={0} r={55} fill="none" stroke="#4CAF50" strokeWidth={3} opacity={0.6} />
        <circle cx={0} cy={0} r={38} fill="#00796B" opacity={0.4} />
      </g>
    </svg>
  );
}
